import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  IconButton,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { Administrator } from '../types/auth';
import KymaBrandTitle from '../components/common/KymaBrandTitle';
import { getPostLoginHomePath } from '../utils/adminAccess';

// 디버깅을 위한 로그 추가
console.log('[Login.tsx] 컴포넌트 파일 로드됨');

const Login: React.FC = () => {
  const { login, authState } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('[Login.tsx] 컴포넌트 렌더링 시작');
    console.log('[Login.tsx] 현재 인증 상태:', authState.isAuthenticated ? '인증됨' : '미인증');
    if (authState.isAuthenticated && !authState.loading) {
      navigate(getPostLoginHomePath(authState.user), { replace: true });
    }
  }, [authState.isAuthenticated, authState.loading, authState.user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      console.log('[Login.tsx] 로그인 시도:', username);
      const success = await login(username, password);
      console.log('[Login.tsx] 로그인 결과:', success);

      if (!success) {
        setError('로그인에 실패. 사용자명과 비밀번호를 확인');
      }
      // 성공 시 useEffect 가 user 기준으로 홈 이동
    } catch (err) {
      console.error('[Login.tsx] 로그인 실패:', err);
      setError('로그인 중 오류 발생');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'username') {
      setUsername(value);
    } else if (name === 'password') {
      setPassword(value);
    }
    
    if (error) setError(null);
  };

  const togglePasswordVisibility = () => {
    // Implementation of togglePasswordVisibility function
  };
  
  console.log('[Login.tsx] 최종 렌더링');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: { xs: 1.5, sm: 3 },
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 4 },
          width: '100%',
          maxWidth: 450,
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <KymaBrandTitle variant="central" tone="default" size="medium" align="center" />
        </Box>
        <Box>
          <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mb: 3 }}>
            관리자 계정으로 로그인
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="아이디"
              name="username"
              value={username}
              onChange={handleInputChange}
              margin="normal"
              variant="outlined"
              autoComplete="username"
              autoFocus
            />
    
            <TextField
              fullWidth
              label="비밀번호"
              name="password"
              type="password"
              value={password}
              onChange={handleInputChange}
              margin="normal"
              variant="outlined"
              autoComplete="current-password"
            />
          
            {(error || authState.error) && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error || authState.error}
              </Alert>
            )}
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 3, mb: 2 }}
              disabled={authState.loading}
            >
              {authState.loading ? <CircularProgress size={24} /> : '로그인'}
            </Button>
          </form>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login; 